export default __webpack_public_path__ + "fonts/iconfont.54d058c2a84da5389bba15fdec7eca43.eot";